export default {
  loading: false,
  vender_types: [],
  totalCount: 0,
};
